import { useState, useEffect } from 'react';
import { NotificationPreferences } from './NotificationPreferences';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';
import { supabase } from '../utils/supabase/client';
import { AuthButton } from './AuthButton';

export function NotificationPreferencesPage() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [accessToken, setAccessToken] = useState('');

  useEffect(() => {
    const checkAuth = async () => {
      const storedUser = localStorage.getItem('pathkit_user');
      const storedToken = localStorage.getItem('pathkit_session_id') || localStorage.getItem('pathkit_access_token');
      
      if (storedUser && storedToken) {
        setUser(JSON.parse(storedUser));
        setAccessToken(storedToken);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const handleBack = () => {
    window.history.back();
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl mb-2">Loading...</div>
          <div className="text-gray-600">Checking authentication</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl mb-4">Please log in</h2>
          <p className="text-gray-600 mb-6">
            You must be logged in to access notification preferences
          </p>
          <Button onClick={() => (window.location.href = '/')}>
            Go to Login
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-8 px-4">
        <div className="mb-6 flex items-center justify-between">
          <Button variant="ghost" onClick={handleBack}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
          <AuthButton />
        </div>
        
        <NotificationPreferences
          accessToken={accessToken}
          currentUser={user}
        />
      </div>
    </div>
  );
}